import { Injectable } from '@angular/core';
import { UntypedFormControl, AbstractControl } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AutotextService {
  public currentFieldID: number;
  currentText: AbstractControl;
  public Display = false;
  Title: string;
  isHtml = false;
  summaryDiagnosisAT = [];
  filter = null;
  options = [];
  filteredOptions: Observable<string[]>;
  GYNOPTIONSEXMAS = [
    '1st',
    'NT',
    'Early',
    '2nd/3rd',
    'Weight Assessment',
    'Late',
    'Third Scan',
    'Specialized',
    'Fetal Echo',
  ];
  search = new UntypedFormControl();
  loaded$ = new Subject();
  loaded = false;
  displaySpeechText = false;
  speechTextControl: AbstractControl;
  speechTitle: string;

  constructor(private http: HttpClient) {}

  showAuto(formObj: AbstractControl, title: string, formID: any, display = true, isHtml = false) {
    this.currentText = formObj;
    this.Title = title;
    this.currentFieldID = formID;
    this.isHtml = isHtml;
    this.Display = display;
  }

  getTexts(field = this.currentFieldID.toString(), filter = this.filter) {
    let res = this.http.get('/api/autotext', { params: { field: field, filter: filter } });
    return res;
  }

  saveText(txt: string, id: number, move = false) {
    if (move) {
      let res = this.http.post('/api/autotextMove', { Text: txt, DlgID: this.currentFieldID });
      return res;
    }
    let res = this.http.post('/api/autotext', {
      Text: txt,
      DlgID: this.currentFieldID,
      ID: id,
      filter: this.filter,
    });
    return res;
  }

  delete(id: number) {
    let res = this.http.delete('/api/autotext', { params: { ID: id.toString() } });
    return res;
  }

  updatePriority(id: number, priority: number) {
    let res = this.http.post('/api/autotext/priority', { ID: id, Priority: priority });
    return res;
  }

  close() {
    this.Display = false;
  }
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.options.filter((option) => option.toLowerCase().includes(filterValue));
  }

  async loadData(form: UntypedFormControl) {
    this.loaded = false;
    await this.http.get('/api/newExams/getAutoInput').subscribe((data: any) => {
      this.options = [];
      for (let txt of this.GYNOPTIONSEXMAS) this.options.push(txt);
      // this.options = this.GYNOPTIONSEXMAS;
      if (data.length > 0) {
        data.forEach((i) => {
          this.options.push(i.Text);
        });
      }
      this.filteredOptions = form.valueChanges.pipe(
        startWith(''),
        map((value) => this._filter(''))
      );
      this.loaded$.next(undefined);
      this.loaded = true;
    });
  }
  deleteAuto(option) {
    this.http.delete('/api/newExams/deleteOption/' + option).subscribe((data) => {
      console.log(data);
      this.options = [];
      this.filteredOptions = this.search.valueChanges.pipe(
        startWith(''),
        map((value) => this._filter(''))
      );
    });
  }

  sendToAI(
    text: string,
    system: string,
    examtype: string,
    examid: number,
    instructions = '',
    language = '',
    scope: 'consultation' | 'full' = 'consultation'
  ): Observable<any> {
    const encodedExamptype = encodeURIComponent(examtype);
    return this.http.post(`/api/Findings/sendAI/${encodedExamptype}/${system}`, {
      transcript: text,
      examid: examid,
      instructions: instructions,
      language: language,
      scope: scope,
    });
  }

  // doctor's change requests on the results already saved from the last sendToAI
  refineAI(
    instructions: string,
    system: string,
    examtype: string,
    examid: number,
    scope: 'consultation' | 'full' = 'consultation'
  ): Observable<any> {
    const encodedExamptype = encodeURIComponent(examtype);
    return this.http.post(`/api/Findings/refineAI/${encodedExamptype}/${system}`, {
      examid: examid,
      instructions: instructions,
      scope: scope,
    });
  }

  getTranscripts(examid: number): Observable<any> {
    return this.http.get(`/api/Findings/transcripts/${examid}`);
  }

  // English medical terms for the speech recognizer (aweb-api prompts/medical_vocabulary.txt)
  getVocabulary(): Observable<{ phrase: string; boost: number }[]> {
    return this.http.get<{ phrase: string; boost: number }[]>('/api/Findings/vocabulary');
  }
}
